import { render, staticRenderFns } from "./FnFormatUser.vue?vue&type=template&id=8a1c2876&"
import script from "./FnFormatUser.vue?vue&type=script&lang=js&"
export * from "./FnFormatUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a1c2876')) {
      api.createRecord('8a1c2876', component.options)
    } else {
      api.reload('8a1c2876', component.options)
    }
    module.hot.accept("./FnFormatUser.vue?vue&type=template&id=8a1c2876&", function () {
      api.rerender('8a1c2876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-format/components/FnFormatUser.vue"
export default component.exports